module.exports = __webpack_public_path__ + "front/img/6-1_a.a7549445.png";